import React from 'react';
import 'twin.macro';
import { StaticImage } from 'gatsby-plugin-image';

import Layout from '~components/Layout';
import SEO from '~components/SEO';
import Hero, { heroImgStyles } from '~components/Hero';
import Panel from '~components/Panel';
import Text, { ConstrainedText } from '~components/Text';

// Page Navigation
import PageNav from '~components/PageNav';
import CaleahCard from '~components/PageCard/CaleahCard';
import CharliMaeCard from '~components/PageCard/CharliMaeCard';

import { roundedImg } from '~theme';

const StubPage: React.FC = () => {
  return (
    <Layout>
      <SEO title="Fanny Guimont-Desrochers, PhD, SCYM, Chercheur en immunologie,
diagnostic à l’âge de 5 ans
" desc="Description" />
      <Hero title="Fanny Guimont-Desrochers, PhD, SCYM, Chercheur en immunologie,
diagnostic à l’âge de 5 ans
">
        <StaticImage style={heroImgStyles} src="../../images/fanny.jpg" alt="" />
      </Hero>
      <div tw="container">
        <ConstrainedText>
        J’ai reçu le diagnostic du DT1 à l’âge de 5 ans. Cela a immédiatement bouleversé ma vie. Je devais me piquer les doigts et m’injecter de l’insuline plusieurs fois par jour. On pourrait penser que les injections étaient le pire aspect, mais la gestion de la maladie était bien plus difficile.
        </ConstrainedText>
        <ConstrainedText>
        Vivre avec le DT1, c’est comme se demander à chaque instant si son corps va nous lâcher, que ce soit à cause d’une glycémie trop basse (qui peut provoquer un coma si elle n’est pas traitée), d’une glycémie trop élevée ou de complications à long terme liées au DT1 (comme la cécité, une crise cardiaque ou des lésions rénales). C’est également la raison pour laquelle je suis devenu chercheur scientifique afin de faire avancer la cause de la guérison du DT1.
        </ConstrainedText>
        <ConstrainedText>
        Nous devons accélérer le rythme de la recherche sur le DT1, car nous sommes à la croisée des chemins. De nombreuses innovations prometteuses sont sur le point de devenir réalité, et nous devons les mettre à la disposition de tous ceux qui en ont besoin.
        </ConstrainedText>
        <ConstrainedText>
        De nouveaux domaines de recherche s’ouvrent et laissent entrevoir des thérapies ou des guérisons potentiels prometteurs que nous n’aurions jamais cru possibles. De meilleurs traitements et même une guérison pour le DT1 n’ont jamais été aussi proches qu’aujourd’hui.
        </ConstrainedText>
        <ConstrainedText>
        Récemment, j’ai eu deux grossesses sans danger (sans hypoglycémie dangereuse) et des bébés en parfaite santé. Vivre avec le DT1 reste un défi que j’ai dû relever à chaque instant au cours des 30 dernières années. C’est pourquoi je suis si engagée à travailler avec FRDJ pour guérir le diabète.
        </ConstrainedText>
      </div>
      <Panel variant="blue">
        <div tw="grid gap-6 items-center lg:(grid-cols-2)">
          <div tw="lg:order-2 max-w-2xl">
            <StaticImage src="../../images/fanny-sm.jpg" alt="" style={roundedImg} />
          </div>
          <div tw="lg:order-1">
            <Text tw="text-2xl">
            En aidant FRDJ à trouver un moyen de guérir le DT1, on évitera à d’autres enfants de perdre leur enfance. Un enfant de 5 ans devrait penser à jouer avec ses amis, pas à sa prochaine injection d’insuline. Nous avons des scientifiques extrêmement talentueux qui travaillent sur de meilleurs traitements et guérisons. Ils ont besoin de notre aide.
            </Text>
          </div>
        </div>
      </Panel>
      <div tw="container">
        <PageNav previous={<CaleahCard />} next={<CharliMaeCard />} />
      </div>
    </Layout>
  );
};

export default StubPage;
